export enum CrossdockActionTypes {
  SET_CROSSDOCK_INBOUND_QUOTE = "SET_CROSSDOCK_INBOUND_QUOTE",
  SET_CROSSDOCK_INBOUND_SHIPMENT = "SET_CROSSDOCK_INBOUND_SHIPMENT",
}
